// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"b3495f14","528":"1c20ab6a","767":"fe045909","890":"c408c6a0"}[chunkId] + ".chunk.css";
};